<section>
  <div class="row">
    <div class="col">
      <h2> <strong> Acepto términos y condiciones </strong> </h2>
    </div>
  </div>

  <div class="row">
    <div class="card-policy col text-justify">
       <div class=" text-justify"  [innerHTML]="condicionesFull" >

       </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col flex-container">
      <button mat-button class="btn-danger-custom" mat-dialog-close>
        Entendido
      </button>
    </div>
  </div>
</section>
